import { isIapRequested } from './iapSession'
import { isJottacloudAndroidApp } from './jottacloudAndroidApp'

/**
 * Inside the Jottacloud Android app, web upgrade and subscription management
 * only fit visits the app opened with ?iap=true. Other app visits hide those
 * entry points, and the upgrade page sends the user to settings.
 */
export function isSubscriptionHidden() {
  return isJottacloudAndroidApp(navigator.userAgent) && !isIapRequested()
}
